<template>
  <v-row class="match-height">
    <!-- all clients -->
    <v-col
      cols="12"
      md="12"
    >
      <v-card>
        <v-card-title>All Accounts</v-card-title>
        <v-card-text>
          <all-clients />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import AllClients from '@/components/users/all-clients.vue'

export default {
  components: {
    AllClients,
  },
  setup() {
    return {}
  },

  mounted() {
    //
  },
}
</script>
